import { render } from "./ListaSolicitudes.vue?vue&type=template&id=d10c198c"
import script from "./ListaSolicitudes.vue?vue&type=script&lang=js"
export * from "./ListaSolicitudes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__